import { RefObject, useEffect, useRef, useState } from "react";

type UseIsElementVisibleProps = {
  scrollableContainerRef?: RefObject<HTMLElement | null>;
  active?: boolean;
};

export const useIsElementVisible = ({ scrollableContainerRef, active }: UseIsElementVisibleProps = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observedElement = elementRef.current;
    if (!observedElement || active === false) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0,
        root: scrollableContainerRef?.current || null,
        rootMargin: "400px"
      }
    );

    observer.observe(observedElement);

    return () => {
      observer.unobserve(observedElement);
    };
  }, [active]);

  return { isVisible, elementRef };
};
